import React, {Component} from 'react';
import {default as CartItem} from './CartItem/Container';
import MainStore from '../stores/MainStore.js';

class CartList extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  };

  render() {
    //console.log( window.__cart );
    //console.log( MainStore.cart );
    
    return (
      <React.Fragment>
        <table className="table table-borderless cart_list_table mt-3">
            <tbody>
              { MainStore.cart!==null && MainStore.cart.items.length>0 && MainStore.cart.items.map((data, i) => 
                <CartItem 
                  key = {"cart_item_"+data.key}
                  data = {data}
                />
              )}
            </tbody>
        </table>
      </React.Fragment>
    )
  };
}
export default CartList;